/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';

/**
 * A threshold marker with optional rewards
 * @export
 * @interface GamificationMilestone
 */
export interface GamificationMilestone {
    /**
     * Numeric threshold value (type interprets meaning — 50% for Lock-In, 3 patterns for Bingo, etc.)
     * @type {number}
     * @memberof GamificationMilestone
     */
    threshold: number;
    /**
     * 
     * @type {string}
     * @memberof GamificationMilestone
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof GamificationMilestone
     */
    reached: boolean;
    /**
     * 
     * @type {number}
     * @memberof GamificationMilestone
     */
    reachedAt?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GamificationMilestone
     */
    rewardConfigIds?: Array<string>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof GamificationMilestone
     */
    rewardGrants?: Array<RewardGrant>;
}

/**
 * Check if a given object implements the GamificationMilestone interface.
 */
export function instanceOfGamificationMilestone(value: object): value is GamificationMilestone {
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('reached' in value) || value['reached'] === undefined) return false;
    return true;
}

export function GamificationMilestoneFromJSON(json: any): GamificationMilestone {
    return GamificationMilestoneFromJSONTyped(json, false);
}

export function GamificationMilestoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationMilestone {
    if (json == null) {
        return json;
    }
    return {
        
        'threshold': json['threshold'],
        'label': json['label'],
        'reached': json['reached'],
        'reachedAt': json['reachedAt'] == null ? undefined : json['reachedAt'],
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
    };
}

export function GamificationMilestoneToJSON(json: any): GamificationMilestone {
    return GamificationMilestoneToJSONTyped(json, false);
}

export function GamificationMilestoneToJSONTyped(value?: GamificationMilestone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threshold': value['threshold'],
        'label': value['label'],
        'reached': value['reached'],
        'reachedAt': value['reachedAt'],
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
    };
}

